/**
 * Whitelist of enter and center effects accepted from the server.
 * Mirrors PHP enums PopupEnterEffect / PopupCenterEffect. Keep in sync.
 *
 * Used to sanitize the `enter`/`center` strings before they are concatenated into a CSS class —
 * never trust the server-side payload blindly even for our own data.
 */
const ENTER = new Set([
  'fade', 'pop', 'slide_down', 'slide_up', 'flip',
  'slide_left', 'slide_right', 'zoom_in', 'zoom_out', 'rotate', 'bounce_in', 'swing_in',
]);
const CENTER = new Set([
  'none', 'pulse', 'spin', 'float', 'glow', 'shake',
  'bounce', 'wobble', 'swing', 'flash', 'heartbeat', 'tada',
  'zoom', 'flip', 'flip_x', 'roll', 'jello', 'rubber_band', 'tilt', 'drift',
]);

export const EffectsRegistry = {
  enter(name: string): string {
    return ENTER.has(name) ? name : 'fade';
  },
  center(name: string): string {
    return CENTER.has(name) ? name : 'none';
  },
};
